import { all } from "redux-saga/effects";

import getTabsContentSaga from "./getTabsContent";
import getListResearchReportSaga from "./getListResearchReport"
import getResearchReportDetail from "./getResearchReportDetail"

export default function* researchReportSaga() {
  yield all([
    getTabsContentSaga(),
    getListResearchReportSaga(),
    getResearchReportDetail()
  ]);
}
